/**
 * Iterate over a NodeList safely (IE11)
 *
 * @param {array} array
 * @param {function} callback (index, value)
 * @param {function} scope
 */
export default function(array = [], callback, scope) {
    if (array.length <= 0) {
        return;
    }
    for (let i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]); // passes back stuff we need
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/nodeListForEach.js